<app-modal #confirmGrantOnlineAccessToCaxtonModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Do you want to grant access?</h2>
    </div>
    <div class="modal-body">
      <p>
        You should only grant access to patients who are on trials
        that do not support caxton card management in the app.
      </p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="onConfirmGrantAccess()" class="btn btn-primary">
            <span>Continue</span>
          </a>
        </div>
        <div class="col-6">
          <a (click)="confirmGrantOnlineAccessToCaxtonModal.hide()" class="btn btn-secondary"
            data-dismiss="modal">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #grantOnlineAccessToCaxtonFormModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Grant patient online access to caxton</h2>
    </div>
    <div class="modal-body">
      <form [formGroup]="caxtonOnlineAccessForm">
        <table aria-hidden="true" class="simple-form">
          <tr>
            <th><label for="email">Email Address</label></th>
            <td>
              <div class="form-group">
                <input class="form-control" formControlName="email" id="email" type="text">
              </div>
            </td>
          </tr>
          <tr>
            <th><label for="firstname">First Name</label></th>
            <td>
              <div class="form-group">
                <input class="form-control" formControlName="firstName" id="firstName" type="text">
              </div>
            </td>
          </tr>
          <tr>
            <th><label for="lastname">Last Name</label></th>
            <td>
              <div class="form-group">
                <input class="form-control" formControlName="lastName" id="lastName" type="text">
              </div>
            </td>
          </tr>
          <tr>
            <th><label for="title">Gender</label></th>
            <td>
              <div class="form-group">
                <app-dropdown-input #genderSelect id="gender" [options]="genderOptions"
                  [parentForm]="caxtonOnlineAccessForm" name="gender" placeholder="Select gender">
                </app-dropdown-input>
              </div>
            </td>
          </tr>
          <tr>
            <th><label>DOB</label></th>
            <td>
              <div class="form-group">
                <input type="text" #dob class="date form-control" data-toggle="datepicker"
                  formControlName="dateOfBirth">
              </div>
            </td>
          </tr>
        </table>
      </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <button [disabled]="isCaxtonAccessProcessing || caxtonOnlineAccessForm.invalid"
            (click)="onGrantOnlineAccessToCaxtonFormSubmit()" class="btn btn-primary"
            [ngClass]="{'disabled': isCaxtonAccessProcessing}">
            <span *ngIf="isCaxtonAccessProcessing">
              <span class="caxton-access-processing-spinner spinner-border spinner-border-sm" role="status"
                aria-hidden="true"></span>
            </span>
            <span *ngIf="!isCaxtonAccessProcessing">Continue</span>
          </button>
        </div>

        <div class="col-6">
          <button (click)="grantOnlineAccessToCaxtonFormModal.hide()" class="btn btn-secondary"
            data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</app-modal>